import React, { useState, MutableRefObject, useEffect } from 'react';
import { IconFont } from '@/components';
import classNames from 'classnames';
import styles from './index.module.less';
interface Props {
  el: MutableRefObject<any>;
  customClass?: string;
}
const FullScreen: React.FC<Props> = (props: Props) => {
  const { customClass = '', el } = props;
  const [top, setTop] = useState<number>(0);
  const [left, setLeft] = useState<number>(0);
  useEffect(() => {
    if (el.current) {
      const { top, right } = el.current.getBoundingClientRect();
      setTop(top + 10);
      setLeft(right - 50);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [el.current]);
  const customClassNames = classNames(styles.main, customClass);
  const handleFullScreen = () => {
    el.current?.requestFullscreen();
  };
  let display = 'block';
  if (document.fullscreenElement) {
    display = 'none';
  } else {
    display = 'block';
  }
  return (
    <div
      className={customClassNames}
      onClick={handleFullScreen}
      style={{ top: `${top}px`, left: `${left}px`, display }}
    >
      <IconFont type="icon-quanping" style={{ fontSize: '32px' }} />
    </div>
  );
};

export default FullScreen;
